"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var reduceBy_1 = __importDefault(require("ramda/src/reduceBy"));
/**
 * useBuildForm is a data transform hook that returns a map
 * containing group and ungroup fields.
 *
 * @param fields list of groups
 * @param tittles list of titles
 * @param values record of key name and values
 *
 * ```typescript
 *
 * const fields = [
 *  {
 *    id: 1,
 *    name: "foo"
 *  }
 * ]
 *
 * const titles = [
 *  "Title 1"
 * ]
 *
 * const values = {
 *    id: 1,
 *    name: "foo"
*  }
 *
 * const { grouped, ungrouped } = useBuildForm({
 *  fields,
 *  titles,
 *  values
 * })
 *
 * ```
 */
var useBuildForm = function (_a) {
    var fields = _a.fields, titles = _a.titles, values = _a.values;
    var groups = function (acc, payload) {
        var name = payload.name;
        var field = __assign(__assign({}, payload), { value: typeof values[name] !== 'undefined' ? values[name] : null });
        return acc.concat(field);
    };
    var keys = function (_a) {
        var groupId = _a.groupId;
        return (groupId !== null ? groupId : 'ungrouped');
    };
    var reduceFields = (0, reduceBy_1.default)(groups, [], keys, fields);
    var grouped = titles.map(function (title, index) { return ({ title: title, fields: reduceFields[index] }); });
    var ungrouped = reduceFields.ungrouped ? reduceFields.ungrouped : null;
    return {
        grouped: grouped,
        ungrouped: ungrouped
    };
};
exports.default = useBuildForm;
//# sourceMappingURL=use-build-form.js.map